import React, { useState } from 'react';
import './GuestCoupon.scss'; 
import axios from 'axios';
import HolidayContactDetails from '../ContactDetails/HolidayContactDetails';
const GuestCoupon = (props) => {
  const { onCouponApply, bookingReqData } = props;
  const startDate= props?.bookingReqData?.arrivalDate
  const endDate= props?.bookingReqData?.departureDate

  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const [isInvalid, setIsInvalid] = useState(false);
  const [reservationCouponId, setreservationCouponId] = useState('');
  const formatDate = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) {
      console.error("Invalid date:", date);
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const couponData = {
    startingDate: formatDate(props?.bookingReqData?.arrivalDate),
    endingDate: formatDate(props?.bookingReqData?.departureDate),
    listingMapId: props?.bookingReqData?.listingMapId,
    couponName: code,
  };
  
  const isCouponDataValid = (data) => {
    return data.startingDate && data.endingDate && data.listingMapId && data.couponName;
  };
  const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI3NzA3MSIsImp0aSI6IjExZjBlNjdlNmFmZDBmYzNmN2M5Njg1YjcxOGE1Y2Y0YTFlZDMyZjE2OWE3MzJjYTE5OTNjYTUzYmJkY2IzZjQ4NTAxMjAzY2FhMDJjNzZhIiwiaWF0IjoxNzE4MTA3Mjc1LjM0ODQ0MiwibmJmIjoxNzE4MTA3Mjc1LjM0ODQ0MywiZXhwIjoyMDMzNjQwMDc1LjM0ODQ0Nywic3ViIjoiIiwic2NvcGVzIjpbImdlbmVyYWwiXSwic2VjcmV0SWQiOjM0MjkyfQ.JEXZ305Asbu1zoMvKFwIOflMM0UERObxDEMNde2JvMO2k77e9w74oFkD2AoU933Q7CViXLrL5xaRwAWHQCN72V5SslKPcWsMeAnvfGJM4FDRSAKrJZSmcOm9L_EZXAZgU0zcWhQu2AvtKbxiLBajYCll8KiDEoRFgYMmsiXE5RA'

  const fetchBookingPrice = async (couponData) => {
    if (isCouponDataValid(couponData)) {
      try {
        const response = await axios.post(`https://api.hostaway.com/v1/reservationCoupons`, couponData, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data; 
      } catch (error) {
        console.error('Error fetching booking price data:', error);
        return null;
      }
    } else {
      console.error("couponData is missing required fields:", couponData);
      return null;
    }
  };
  const handleCouponCheck = async () => {
    const listingMapIds = bookingReqData?.listingMapId;
    if (!listingMapIds) {
      setMessage('Please select dates!');
      setIsInvalid(true);
      return;
    }
    if(couponData.startingDate===couponData.endingDate){
      setMessage('Please select dates!');
      setIsInvalid(true);
      return;
    }
    if (!code) {
      setMessage('Please enter a coupon code!');
      setIsInvalid(true);
      return;
    }
    const result = await fetchBookingPrice(couponData);
    const reservationCoupon = result?.result?.reservationCouponId;
    const ranges ={
      selection:{
        startDate,
        endDate
      }
    }
    if (reservationCoupon) {
      //localStorage.setItem('reservationCouponId', reservationCouponId);
      const ranges ={
        selection:{
          startDate,
          endDate
        }
      }
      onCouponApply(reservationCoupon,ranges);
    }else{
      localStorage.removeItem('reservationCouponId');
      onCouponApply(null,ranges);
    }
    applyDiscount(result);
  };

  const applyDiscount = (result) => {
    if (result?.status === 'success') {
      setMessage('Discount successfully applied!'); 
      setIsInvalid(false); 
      setreservationCouponId(result?.result?.reservationCouponId)
    } else {
      setMessage(`Coupon ${code} not found`);
      setIsInvalid(true);
      setreservationCouponId("122333")
    }
  };

  
  return (
    <div className="discount-section">
      <div className="input-btn-container">
        <input 
          type="text" 
          className="discount-input" 
          value={code} 
          onChange={(e) => setCode(e.target.value)} 
          placeholder="Discount" 
        />
        <button className="apply-btn" onClick={handleCouponCheck}>
          Apply
        </button>
      </div>
      {message &&   <p className={`message ${isInvalid ? 'invalid' : ''}`}>{message}</p>}
    </div>
  );
};

export default GuestCoupon;
